import * as constants from "../constants/constants";

// --- New typed interfaces ---

export interface ServicingStats {
    registered: number;
    diagnosing: number;
    waitingMaterial: number;
    repairing: number;
    waitingClient: number;
    completed: number;
    waiting: number;
    active: number;
}

export interface Pagination {
    currentPage: number;
    lastPage: number;
    perPage: number;
    total: number;
}

export interface ServiceState {
    // New state
    stats: ServicingStats | null;
    servicings: any[];
    servicingsPagination: Pagination;
    servicingsCities: any[];
    currentServicing: any | null;
    locations: any[];
    // Legacy state
    serviceRecords: any;
    serviceRecordsPagination: any;
    projectsReadyForService: any;
    fetchedService: any;
    selectedProjectForService: any;
    serviceMapData: any;
}

const defaultPagination: Pagination = { currentPage: 1, lastPage: 1, perPage: 20, total: 0 };

const parsePagination = (meta: any): Pagination => {
    if (!meta) return { ...defaultPagination };
    return {
        currentPage: Number(meta.current_page) || 1,
        lastPage: Number(meta.last_page) || 1,
        perPage: Number(meta.per_page) || 20,
        total: Number(meta.total) || 0,
    };
};

const initialState = (): ServiceState => {
    return {
        // New
        stats: null,
        servicings: [],
        servicingsPagination: { ...defaultPagination },
        servicingsCities: [],
        currentServicing: null,
        locations: [],
        // Legacy
        serviceRecords: [],
        serviceRecordsPagination: { ...defaultPagination },
        projectsReadyForService: [],
        fetchedService: {},
        selectedProjectForService: {},
        serviceMapData: [],
    };
};

const service = (state: ServiceState = initialState(), action: any) => {
    switch (action.type) {
        // --- New actions ---

        case constants.FETCH_SERVICING_DASHBOARD_STATS:
            return { ...state, stats: action.payload };

        case constants.FETCH_SERVICINGS:
            return {
                ...state,
                servicings: action.payload.data || [],
                servicingsPagination: parsePagination(action.payload.meta),
                servicingsCities: action.payload.cities ?? [],
            };

        case constants.FETCH_SERVICING_NEW:
            return { ...state, currentServicing: action.payload };

        case constants.FETCH_SERVICING_LOCATIONS:
            return { ...state, locations: action.payload || [] };

        // --- Legacy actions ---

        case constants.FETCH_SERVICE_RECORDS: {
            return {
                ...state,
                serviceRecords: action.payload.data || action.payload,
                serviceRecordsPagination: action.payload.meta ? {
                    currentPage: action.payload.meta.current_page || 1,
                    lastPage: action.payload.meta.last_page || 1,
                    perPage: action.payload.meta.per_page || 20,
                    total: action.payload.meta.total || 0
                } : state.serviceRecordsPagination
            };
        }
        case constants.FETCH_PROJECTS_FOR_SERVICE: {
            return {
                ...state,
                projectsReadyForService: action.payload
            };
        }
        case constants.FETCH_SERVICE: {
            return {
                ...state,
                fetchedService: action.payload
            };
        }
        case constants.SET_SELECTED_PROJECT_FOR_SERVICE: {
            return {
                ...state,
                selectedProjectForService: action.payload
            };
        }
        case constants.GET_SERVICE_MAP_DATA: {
            return {
                ...state,
                serviceMapData: action.payload
            };
        }
    }
    return state;
};

export default service;
